module.exports = __webpack_public_path__ + "img/zip.85c0914e.svg";